export default {"src":"/_next/static/media/VLTO.f4b53a28.svg","height":18,"width":18};